export default {
  getCompaniesList: 'GET_COMPANIES_LIST',
  getCompaniesListSuccess: 'GET_COMPANIES_LIST_SUCCESS',
  getCompaniesListFailed: 'GET_COMPANIES_LIST_FAILED',
  addNewCompany: 'ADD_NEW_COMPANY',
  addNewCompanySuccess: 'ADD_NEW_COMPANY_SUCCESS',
  addNewCompanyFailed: 'ADD_NEW_COMPANY_FAILED',
  toggleCompanyForm: 'TOGGLE_COMPANY_FORM',
  resetToInitialState: 'COMPANY_FORM_RESET_TO_INITIAL_STATE',
  updateCompanyDetails: 'UPDATE_COMPANY_DETAILS',
  updateCompanyDetailsSuccess: 'UPDATE_COMPANY_DETAILS_SUCCESS',
  updateCompanyDetailsFailed: 'UPDATE_COMPANY_DETAILS_FAILED',
  companyProfileUpdate: 'COMPANY_PROFILE_UPDATE',
  companyProfileUpdateSuccess: 'COMPANY_PROFILE_UPDATE_SUCCESS',
  companyProfileUpdateFailed: 'COMPANY_PROFILE_UPDATE_FAILED',
  deleteCompany: 'DELETE_COMPANY',
  deleteCompanySuccess: 'DELETE_COMPANY_SUCCESS',
  deleteCompanyFailed: 'DELETE_COMPANY_FAILED',
};
